import React, { useEffect, useState } from 'react';
import {
  Button,
  Paper,
  Typography,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  InputAdornment,
  Tabs,
  Tab,
  Box,
  Chip,
  Grid,
  Card,
  CardContent,
  Divider,
  IconButton,
  Tooltip,
  CircularProgress
} from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { 
  currencyFormat, 
  isEven, 
  daysOfTheWeek, 
  mtcFrequencies 
} from '../../services/common';
import { connect } from 'react-redux';
import axios from 'axios';
import SearchIcon from '@material-ui/icons/Search';
import EditIcon from '@material-ui/icons/Edit';
import AssignmentIcon from '@material-ui/icons/Assignment';
import WarningIcon from '@material-ui/icons/Warning';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import EditJobSiteModal from './MaintenanceStuff/EditJobSiteModal';
import moment from 'moment';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import TrendingDownIcon from '@material-ui/icons/TrendingDown';
import RemoveIcon from '@material-ui/icons/Remove';

import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import FilterBar from './MaintenanceStuff/CrewAssignmentPage/FilterBar'
import AlertsSystem from './MaintenanceStuff/CrewAssignmentPage/AlertsSystem'
import {
  calculateMonthlyValue,
  StarRating,
  isSiteDueForReview,
  isOverdue,
  getSiteReviewMetrics
} from './MaintenanceStuff/CrewAssignmentPage/utils'
import SiteReviewPriorityPanel from './MaintenanceStuff/CrewAssignmentPage/SiteReviewPriorityPanel';
import RowDetails from './MaintenanceStuff/CrewAssignmentPage/RowDetails'

let weekOfTheYear = moment(new Date()).week()

const defaultVals = {
  sites: [],
  searchValue: '',
  crewToConfirm: null,
  siteToConfirm: null,
  evenOrOddWeeks: 'Odd',
  // ADD THESE NEW FILTER PROPERTIES:
  filters: {
    customerType: '',
    frequency: '',
    preferredDay: '',
    crew: '',
    evenOrOddWeeks: '',
    assignmentStatus: '',
    overdueService: '',
    overdueSiteReview: ''
  }
}

const HMICrewAssignmentComponent = (props) => {
  const classes = useStyles();
  const theme = useTheme()
  const [state, setState] = useState(defaultVals);
  const [tabValue, setTabValue] = useState(0);
  const [searchValue, setSearchValue] = useState('');
  const [filteredRows, setFilteredRows] = useState([]);
  const [showEditJobsiteModal, setShowEditJobsiteModal] = useState(false);
  const [activeSite, setActiveSite] = useState({});
  const [loading, setLoading] = useState(false);
  const [siteReviews, setSiteReviews] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: 'asc'
  });
  const [filters, setFilters] = useState({
    customerType: '',
    frequency: '',
    preferredDay: '',
    crew: '',
    evenOrOddWeeks: '',
    assignmentStatus: '',
    overdueService: '',
    overdueSiteReview: ''
  });
  const [hmiCrews, setHMICrews] = useState([])

  // const hmiCrews = props.crews.filter(crew => crew.entity === "640a56404965b71a9edd0e7d");
  console.log('hmiCrews...', hmiCrews)
  // Site Reviews Stats
  const pendingReviews = siteReviews.filter(review => review.status === 'Pending').length;
  const requiresResolution = siteReviews.filter(review => review.requiresResolution).length;
  const completedReviews = siteReviews.filter(review => review.status === 'Completed').length;


  useEffect(() => {
    let isMounted = true;
    
    const fetchData = async () => {
      setLoading(true);
      try {
        const [sitesResp, reviewsResp, hmiCrewsWithForemanDetails] = await Promise.all([
          axios.get(`${props.url}/api/hmi/getActiveSites`),
          axios.get(`${props.url}/api/hmi/fetchSiteReviews`),
          axios.get(`${props.url}/api/crews/listCrews?forHMICrewsAssignment=true`)
        ]);
        
        if (isMounted) {
          const sites = sitesResp.data;
          const sitesWTotalValue = sites.map(site => {
            // console.log('Site to do ', site)
            const totalValue = calculateMonthlyValue(site.amount, site.frequency, site.amountType, site.laborDetails || {})
            // console.log('Total Value', site.name, totalValue)
            return {
              ...site,
              monthlyValue: totalValue
            }
          })
          console.log('got hmi crews w/ photos...', hmiCrewsWithForemanDetails)
          
          setHMICrews(hmiCrewsWithForemanDetails?.data?.crews)
          // console.log('Sites w/ total value', sitesWTotalValue)
          filterOut(sitesWTotalValue, searchValue);
          setState(prev => ({ ...prev, sitesWTotalValue }));
          console.log('Set site reviews...', reviewsResp)
          setSiteReviews(reviewsResp.data);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        props.notification({
          type: 'error',
          title: 'Error',
          message: 'Failed to fetch data'
        });
      } finally {
        setLoading(false);
      }
    };

    fetchData();
    return () => {
      isMounted = false;
    };
  }, []);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const sortedRows = React.useMemo(() => {
    if (!sortConfig.key) return filteredRows;

    return [...filteredRows].sort((a, b) => {
      console.log('Sort:', sortConfig.key)
      if (sortConfig.key === 'score') {
        const scoreA = getSiteReviewMetrics(a._id, siteReviews).score || 0;
        const scoreB = getSiteReviewMetrics(b._id, siteReviews).score || 0;
        return sortConfig.direction === 'asc' ? scoreA - scoreB : scoreB - scoreA;
      }
      if (sortConfig.key === 'amount') {
        const scoreA = a.monthlyValue || 0;
        const scoreB = b.monthlyValue || 0;
        return sortConfig.direction === 'asc' ? scoreA - scoreB : scoreB - scoreA;
        
      }
      if (a[sortConfig.key] < b[sortConfig.key]) return sortConfig.direction === 'asc' ? -1 : 1;
      if (a[sortConfig.key] > b[sortConfig.key]) return sortConfig.direction === 'asc' ? 1 : -1;
      return 0;
    });
  }, [filteredRows, sortConfig]);

  const requestSort = (key) => {
    setSortConfig(prevConfig => ({
      key,
      direction: prevConfig.key === key && prevConfig.direction === 'asc' ? 'desc' : 'asc',
    }));
  };

  const TrendIndicator = ({ trend }) => {
    const classes = useStyles();
    switch (trend) {
      case 'up':
        return <TrendingUpIcon className={classes.trendUp} />;
      case 'down':
        return <TrendingDownIcon className={classes.trendDown} />;
      default:
        return <RemoveIcon className={classes.trendNeutral} />;
    }
  };

  const renderTableHeader = () => (
    <TableHead>
      <TableRow>
        {[
          { key: 'clientName', label: 'Client Name' },
          { key: 'name', label: 'Site Name' },
          { key: 'jobName', label: 'Job Name' },
          { key: 'customerType', label: 'Contract Type' },
          { key: 'address', label: 'Address Details' },
          { key: 'preferredDay', label: 'Preferred Day' },
          { key: 'frequency', label: 'Frequency' },
          { key: 'evenOrOddWeeks', label: 'Even/Odd Weeks' },
          { key: 'amount', label: 'Pricing Details' },
          { key: 'crew', label: 'Crew (Foreman)' },
          { key: 'score', label: 'Site Review' }
        ].map(({ key, label }) => (
          <TableCell 
            key={key}
            className={`${classes.headerRow} ${classes.headerCell}`}
            onClick={() => requestSort(key)}
          >
            {label}
            {sortConfig.key === key && (
              <ArrowDropDownIcon 
                className={classes.sortIcon}
                style={{ 
                  transform: sortConfig.direction === 'desc' ? 'rotate(180deg)' : 'none' 
                }}
              />
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );

  const saveThisToTheBackEnd = async (updatedSiteInfo) => {
    console.log('save this', updatedSiteInfo)
    axios({
      method: 'post',
      url:  `${props.url}/api/hmi/assignCrewToAg`,
      data: updatedSiteInfo,
    }).then(response => {
      // console.log("Update", response.data)
      if (response && response.status === 200) {
        props.notification({
          type: 'success',
          title: 'Saved That!',
          message: 'Great job!'
        })
      } else {
        props.notification({
          type: 'warning',
          title: 'Failed to Save That Update!',
          message: response?.data?.message || 'Unknown Error Occurred'
        })
      }

    })
  }
  
  const handleUpdateAssignedCrew = (site, crew) => {
    // console.log('Updat the assignment here:', site, crew)
    setState({...state, crewToConfirm: crew, siteToConfirm: site})
  }

  const handleCancel = () => {
    setState({...state, siteToConfirm: null })
  }

  const handleConfirm = () => {
    // console.log('Confirm this shit', state)
    let crewToAssign = null
    if (state.crewToConfirm && state.crewToConfirm._id) {
      crewToAssign = {
        _id: state.crewToConfirm._id,
        name: `${state.crewToConfirm.name} ${state.crewToConfirm.foremanName ? `(${state.crewToConfirm.foremanName})` : ''}`
      } 
    }
    let newSites = [...state.sites]
    if (state.siteToConfirm) {
      let index = newSites.findIndex(item => {
        if (item._id === state.siteToConfirm._id && state.siteToConfirm.contract === item.contract) {
          return true
        } else {
          return false
        }
      })
      if (index > -1) {
        let siteToUpdate = {...newSites[index]}
        siteToUpdate.crew = crewToAssign?._id
        siteToUpdate.crewName = siteToUpdate.name
        saveThisToTheBackEnd(siteToUpdate)
        newSites[index] = {...siteToUpdate}
        // console.log('w/ our crew:', siteToUpdate)
      } else {
        console.log('Set no Crew on this bitch!!!!!')
      }
    }
    // console.log('New Sites', newSites)
    filterOut(newSites, searchValue)
    setState({...state, siteToConfirm: null, crewToConfirm: null, sites: newSites })
  }

  const handleUpdateTheAssignedWeek = (site, newWeek) => {
    // console.log("Update this", site)
    console.log(newWeek)
    let newSites = [...state.sites]

    let index = newSites.findIndex(item => (item._id === site._id && item.contract === site.contract))
    if (index > -1) {
      let siteToUpdate = {...newSites[index]}
      siteToUpdate.evenOrOddWeeks = newWeek
      // console.log('site to update', siteToUpdate)
      saveThisToTheBackEnd(siteToUpdate)
      newSites[index] = {...siteToUpdate}
      // console.log('w/ our crew:', siteToUpdate)
      setState({...state, sites: newSites })
    }
  }

  const handleUpdateTheSite = (siteToUpdate) => {
    console.log('Update this one', siteToUpdate)
    let siteId = (siteToUpdate && siteToUpdate._id) ? siteToUpdate._id : (siteToUpdate && siteToUpdate.jobSite && siteToUpdate.jobSite._id) ? siteToUpdate.jobSite._id : siteToUpdate.jobSiteId
    console.log('Site ID', siteId)
    siteToUpdate._id = siteId
    console.log('gotta updat our sites...', state)
    let newSites = [...state.sitesWTotalValue].map(item => {
      // console.log(item)
      let itemId = item._id || item.jobSiteId
      if (itemId === siteId) {
        console.log('This is ti!!', item)
        const {
          frequency,
          evenOrOddWeeks,
          crew,
          preferredDay,
          preferredDays,
          amountType,
          amount,
          irrigationCheckFrequency,
          mowingRequirements,
          mowingTime,
          crewSize,
          estimatedHours,
          herbicideApplicationFrequency,
          herbicideApplicationFee,
          herbicideFeeType,
          doNotSentHerbicideInvoices,
          doNotSendHerbicideNotifications,
          laborDetails
        } = siteToUpdate
        const newSite = {
          ...item,
          frequency,
          evenOrOddWeeks,
          crew,
          preferredDay,
          preferredDays,
          amountType,
          amount,
          irrigationCheckFrequency,
          mowingRequirements,
          mowingTime,
          crewSize,
          estimatedHours,
          herbicideApplicationFrequency,
          herbicideApplicationFee,
          herbicideFeeType,
          doNotSentHerbicideInvoices,
          doNotSendHerbicideNotifications,
          laborDetails
        }
        // console.log('site we are using:', newSite)
        // if (newSite && newSite.crew && newSite.crew._id) {
        //   newSite.crew = newSite.crew._id
         
        // }
        if (siteToUpdate?.crew?._id) {
            newSite.crew = siteToUpdate.crew._id
           newSite.crewName = `${siteToUpdate.crew.name} ${siteToUpdate.crew.foremanName ? `(${siteToUpdate.crew.foremanName})` : ''}`
        } else {
          newSite.crewName = 'Unassigned'
        }
        saveThisToTheBackEnd(newSite)

        return newSite
      } else {
        return item
      }
    })
    console.log('Updated sites', newSites)
    filterOut(newSites, searchValue)
    setState(prevState => ({...prevState, sitesWTotalValue: newSites}))
  }

  const handleFilterChange = (filterType, value) => {
    const newFilters = {
      ...state.filters,
      [filterType]: value
    };
    
    setState(prev => ({
      ...prev,
      filters: newFilters
    }));
    
    // Re-apply filters with current search
    filterOut(state.sitesWTotalValue || state.sites, searchValue, newFilters);
  };
  const handleClearFilters = () => {
    const clearedFilters = {
      customerType: '',
      frequency: '',
      preferredDay: '',
      crew: '',
      evenOrOddWeeks: '',
      assignmentStatus: '',
      overdueService: '',
      overdueSiteReview: ''
    };
    
    setState(prev => ({
      ...prev,
      filters: clearedFilters
    }));
    
    // Re-apply with cleared filters
    filterOut(state.sitesWTotalValue || state.sites, searchValue, clearedFilters);
  };

  const handleAlertFilterApply = (newFilters) => {
    // Merge with existing filters instead of replacing
    const updatedFilters = {
      ...state.filters,
      ...newFilters
    };
    
    // Update the main state filters - this was missing!
    setState(prev => ({
      ...prev,
      filters: updatedFilters
    }));
    
    // Apply the filters
    filterOut(state.sitesWTotalValue, searchValue, updatedFilters);
  };

  const applyFilters = (sites, filters = state.filters) => {
    return sites.filter(site => {
      // Customer Type filter
      if (filters.customerType && site.customerType !== filters.customerType) return false;
      
      // Frequency filter - make case insensitive
      if (filters.frequency) {
        const siteFreq = (site.frequency || '').toLowerCase();
        const filterFreq = filters.frequency.toLowerCase();
        if (siteFreq !== filterFreq) return false;
      }
      
      // Preferred Day filter
      if (filters.preferredDay && site.preferredDay !== filters.preferredDay) return false;
      
      // Crew filter
      if (filters.crew) {
        if (filters.crew === 'unassigned') {
          // Show sites with no crew assigned
          if (site.crew && site.crew !== null && site.crew !== '') return false;
        } else {
          // Show sites assigned to specific crew
          if (site.crew !== filters.crew) return false;
        }
      }
      
      // Even/Odd Weeks filter
      if (filters.evenOrOddWeeks) {
        if (filters.evenOrOddWeeks === 'Not Set') {
          // Show sites with no even/odd assignment
          if (site.evenOrOddWeeks && site.evenOrOddWeeks !== '') return false;
        } else {
          // Show sites with specific even/odd assignment
          if (site.evenOrOddWeeks !== filters.evenOrOddWeeks) return false;
        }
      }
      
      // Assignment Status filter
      if (filters.assignmentStatus) {
        const isAssigned = (site.crew && site.crew !== null && site.crew !== '') ? 'Assigned' : 'Unassigned';
        if (isAssigned !== filters.assignmentStatus) return false;
      }
      
      // Overdue Service filter
      if (filters.overdueService) {
        const siteIsOverdue = isOverdue(site);
        if (filters.overdueService === 'Yes' && !siteIsOverdue) return false;
        if (filters.overdueService === 'No' && siteIsOverdue) return false;
      }
      
      if (filters.overdueSiteReview) {
        const reviewIsDue = isSiteDueForReview(site, siteReviews);
        if (filters.overdueSiteReview === 'Yes' && !reviewIsDue) return false;
        if (filters.overdueSiteReview === 'No' && reviewIsDue) return false;
      }

      return true;
    });
  };


  const applyFiltersOLD = (sites, filters = state.filters) => {
    return sites.filter(site => {
      if (filters.customerType && site.customerType !== filters.customerType) return false;
      if (filters.frequency && site.frequency !== filters.frequency) return false;
      if (filters.preferredDay && site.preferredDay !== filters.preferredDay) return false;
      if (filters.crew && site.crew !== filters.crew) return false;
      if (filters.evenOrOddWeeks) {
        if (filters.evenOrOddWeeks === 'Not Set' && site.evenOrOddWeeks) return false;
        if (filters.evenOrOddWeeks !== 'Not Set' && site.evenOrOddWeeks !== filters.evenOrOddWeeks) return false;
      }
      if (filters.assignmentStatus) {
        const isAssigned = site.crew ? 'Assigned' : 'Unassigned';
        if (isAssigned !== filters.assignmentStatus) return false;
      }
      if (filters.overdueService) {
        const siteIsOverdue = isOverdue(site);
        if (filters.overdueService === 'Yes' && !siteIsOverdue) return false;
        if (filters.overdueService === 'No' && siteIsOverdue) return false;
      }
      return true;
    });
  };
  
  const filterOut = (r, searchText, filters = state.filters) => {
    let string = searchText
    let newArr = []
    r.filter(o => {
      Object.keys(o).some(k => {
        if(o[k]) {
          let str = o[k].toString().toLowerCase() 
          if (str.includes(string.toLowerCase())) {
            return newArr.push(o)
          } else {
            return null
          }
        } else {
          return null
        }
      })
    })
    
    // Apply additional filters
    const combinedFilteredRows = applyFilters(newArr, filters);
    setFilteredRows(combinedFilteredRows)
    setLoading(false)
  }
  
  const handleSearch = (e) => {
    if (e.target.value === '') {
      setSearchValue('')
      filterOut(state.sitesWTotalValue || state.sites, '', state.filters)
    } else {
      setSearchValue(e.target.value)
      filterOut(state.sitesWTotalValue || state.sites, e.target.value, state.filters)
    }
  }

  const handleOpenEditSiteModal = (site) => {
    // console.log('Open Edit Site Modal', site)
    setActiveSite(site)
    setShowEditJobsiteModal(true)
  }

  const handleToggleEditJobSiteModal = () => {
    setShowEditJobsiteModal(!showEditJobsiteModal)
  }

  const updateJobSiteAfterEdit = (siteToUpdate) => {
    console.log('Update jobsite... ', siteToUpdate)
    setShowEditJobsiteModal(false)
    handleUpdateTheSite(siteToUpdate)
  }

  const ListOfJobsites = ({ crews, state, filteredRows, ...props }) => {
    const classes = useStyles();
    
    return (
      <Table size="small">
        {renderTableHeader()}
        <TableBody>
          {filteredRows.map((site, index) => {
            // console.log('site', site.name)
            // const { lastReview, trend, score, detailedRatings, hasIssues } = getSiteReviewMetrics(site._id);
            return <RowDetails key={index} handleOpenSite={() => props.handleOpenSite(site)} site={site} siteReviews={siteReviews} />
          })}
        </TableBody>
      </Table>
    );
  };

  // console.log('Sored Rows', sortedRows)
  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <div className={classes.header}>
          <Typography variant="h5" component="h2">
            HMI Crew Assignment
          </Typography>
        </div>
        <AlertsSystem
          sites={state.sitesWTotalValue || []}
          siteReviews={siteReviews}
          onFilterApply={handleAlertFilterApply}
          onSiteEdit={handleOpenEditSiteModal}
          loading={loading}
        />
        {/* {siteReviews.length > 0 && (
          <SiteReviewPriorityPanel
            sites={state.sitesWTotalValue || []}
            siteReviews={siteReviews}
            onScheduleReview={(site) => {
              console.log('Schedule review for:', site.name);
              // You can open a modal, navigate to review page, etc.
              handleOpenEditSiteModal(site);
            }}
            maxDisplay={5} // Show top 5 priority sites
          />
        )} */}
        <FilterBar
          filters={state.filters}
          onFilterChange={handleFilterChange}
          onClearFilters={handleClearFilters}
          sites={state.sitesWTotalValue || state.sites || []}
          resultCount={filteredRows.length}
          crews={hmiCrews}
        />

        <div className={classes.searchContainer}>
          <TextField
            name="search"
            value={searchValue}
            onChange={handleSearch}
            label="Search Sites"
            variant="outlined"
            size="small"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
          <Typography variant="body2">
            Matching Sites: {filteredRows.length}
          </Typography>
        </div>

        {loading ? (
          <Box display="flex" justifyContent="center" m={3}>
            <CircularProgress />
          </Box>
        ) : (
          <ListOfJobsites
            crews={hmiCrews}
            state={state}
            filteredRows={sortedRows}
            updateTheAssignedCrew={handleUpdateAssignedCrew}
            handleCancel={handleCancel}
            handleConfirm={handleConfirm}
            updateTheAssignedWeek={handleUpdateTheAssignedWeek}
            updateTheSite={handleUpdateTheSite}
            handleOpenSite={handleOpenEditSiteModal}
          />
        )}
      </Paper>

      <EditJobSiteModal
        open={showEditJobsiteModal}
        {...props}
        activeSite={activeSite}
        closeAddJobsiteModal={handleToggleEditJobSiteModal}
        updateParent={updateJobSiteAfterEdit}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    authenticated: state.authenticated,
    notification: state.notification,
    url: state.url,
    crews: state.crews
  }
}

export default connect(mapStateToProps)(HMICrewAssignmentComponent)

const useStyles = makeStyles(theme => ({
  root: {
    margin: theme.spacing(2),
  },
  paper: {
    width: '100%',
    height: '100%',
    minHeight: '80vh',
    padding: theme.spacing(3),
  },
  headerRow: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    fontWeight: 'bold',
  },
  headerCell: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  headerContent: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  starIcon: {
    color: theme.palette.primary.main,
    fontSize: '1.2rem',
  },
  starIconSmall: {
    fontSize: '1rem',
  },
  warningIcon: {
    color: theme.palette.warning.main,
    marginLeft: theme.spacing(1),
  },
  reviewScore: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
  },
  ratingRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  daysAgo: {
    color: theme.palette.text.secondary,
    fontSize: '0.75rem',
  },
  sortIcon: {
    marginLeft: theme.spacing(1),
    transition: 'transform 0.2s',
  },
  tooltipContent: {
    padding: theme.spacing(1),
  }
}));
